/* FindImagesSummaryComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./FindImagesSummaryRenderer");

/**
 * Component for displaying summary results after getOsUpgradeLinks work completes.
 * Shows success/failure counts and any error details.
 */
class FindImagesSummaryComponent extends EventEmitter {
    constructor(summaryData, logger) {
        super();
        this._logger = logger;
        this._summaryData = summaryData;
        this._renderer = new Renderer(this);
        this._renderer.render();
    }

    get renderer() {
        return this._renderer;
    }

    get rootElem() {
        return this._renderer.getRootElement();
    }

    get summaryData() {
        return this._summaryData;
    }

    set "$teve.ui.context"(context) {
        this._context = context;
    }

    shutdown() {
        const shutDowns = [this._renderer?.shutdown() || Promise.resolve()];

        return Promise.all(shutDowns).then(() => {
            this.removeAllListeners();
            this._renderer = this._summaryData = this._logger = undefined;
        });
    }

    close() {
        this._context.resolve({success: true});
    }
}

module.exports = FindImagesSummaryComponent;
